const state = {
    dealers: {},
    pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 12, //either 12 or 15 depending on event
        total: 0
    },
    filters: {
        brand: [],
        services: [],
        lat: null,
        lng: null,
        location: null
    },
    isLoading: false,

    availableBrands: {
        'abarth': 'Abarth',
        'alfa-romeo': 'Alfa Romeo',
        'citroen': 'Citroen',
        'ds': 'DS',
        'fiat': 'Fiat',
        'jeep': 'Jeep',
        'leapmotor': 'Leapmotor',
        'peugeot': 'Peugeot',
        'vauxhall': 'Vauxhall',
    },

    availableServices: {
        offers_new: 'New Car Sales',
        offers_used: 'Used Car Sales',
        offers_business: 'Business & Fleet',
        offers_motability: 'Motability',
        offers_parts_hub: 'Parts Hub',
        offers_servicing: 'Offers Servicing',
    },
};

// getters
const getters = {
    currentDealers(state){
        return state.dealers[state.pagination.current_page] ?? [];
    },

    filterableBrands(state){
        return state.availableBrands
    },

    filterableServices(state){
        return state.availableServices
    },

    isBrandSelected(state){
        return (brand) => {
            return state.filters.brand.includes(brand)
        }
    },

    isServiceSelected(state){
        return (service) => {
            return state.filters.services.includes(service)
        }
    },

    query(state){
        return structuredClone(
            {
                ...state.filters,
                page: state.pagination.current_page
            }
        )
    }
};

// actions
const actions = {
    loadQueryParams({ commit, dispatch, state }, route) {
        let options = {...state.filters}

        const allowedKeys = Object.keys(state.filters)
        Object.keys(route.query).forEach((key) => {
            let value = structuredClone(route.query)[key]

            if(key === 'page'){
                commit('setCurrentPage', value) //take 1 so it loads the given page
                return
            }

            if(!allowedKeys.includes(key)){
                return
            }

            options[key] = Array.isArray(options[key]) && !Array.isArray(value)
                ? [...options[key], value]
                : value
        })

        commit('setFilters', options)
    },

    getDealers({ commit, state }, page){
        page = page ?? state.pagination.current_page ?? 1

        if(state.isLoading) return //Don't duplicate requests
        
        return new Promise((resolve, reject) => {
            commit('setIsLoading', true)

            const { location, ...filters } = state.filters

            axios
                .post(
                    '/ajax/dealers/results', 
                    {
                        ...filters,
                        ...location,
                        page
                    }
                )
                .then(response => {
                    const { data, ...pagination } = response.data

                    commit('setDealers', {page, data})
                    commit('setPagination', pagination)

                    resolve(response.data);

                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    })
                })
                .catch(error => {
                    console.error('Error getting vehicle data', error);
                    reject();
                })
                .finally(
                    () => commit('setIsLoading', false)
                )
        })
    },

    resetDealers({ dispatch, commit }){
        commit('resetDealers')
        dispatch('getDealers', 1)
    },

    toggleBrand({ commit, getters }, brand){
        return getters.isBrandSelected(brand)
            ? commit('deselectBrand', brand)
            : commit('selectBrand', brand)
    },

    toggleService({ commit, getters }, service){
        return getters.isServiceSelected(service)
            ? commit('deselectService', service)
            : commit('selectService', service)
    },
};

const mutations = {
    setFilters(state, filters){
        state.filters = filters
    },

    setCurrentPage(state, page){
        state.pagination.current_page = page
    },

    setIsLoading(state, isLoading){
        state.isLoading = isLoading
    },

    setDealers(state, {page, data}){
        state.dealers[page] = data
    },

    resetDealers(state){
        state.dealers = {}
        state.pagination = {
            current_page: 1,
            last_page: 1,
            per_page: 12,
            total: 0
        }
    },

    setPagination(state, pagination){
        state.pagination = {
            current_page: pagination.current_page,
            last_page: pagination.last_page,
            per_page: pagination.per_page,
            total: pagination.total
        }
    },

    setBrands(state, brands){
        state.filters.brand = brands
    },

    setServices(state, services){
        state.filters.services = services
    },

    setLocations(state, location){
        state.filters.location = location
    },

    selectBrand(state, brand){
        state.filters.brand.push(brand)
    },

    deselectBrand(state, brand){
        state.filters.brand.splice(
            state.filters.brand.indexOf(brand),
            1
        )
    },
    
    selectService(state, service){
        state.filters.services.push(service)
    },

    deselectService(state, service){
        state.filters.services.splice(
            state.filters.services.indexOf(service),
            1
        )
    },

    setLocation(state, location){
        if(!location.lat || !location.lng)
            return

        state.filters.lat = location.lat
        state.filters.lng = location.lng

        state.filters.location = location.location ?? 'My Location'
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};